import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { Genre } from "../../types"
import { useDeleteGenre, useGenre, useUpdateGenre } from "../../hooks/genres"
import { initialValuesGenre, validationSchemaGenre } from "./GenreCommon"
import GenreForm from "./GenreForm"

export default function GenreUpdate() {
  const updateGenre = useUpdateGenre()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: genre } = useGenre(Number(id))

  const deleteGenre = useDeleteGenre()

  const [modalStateDeleteGenre, modalActionsDeleteGenre] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesGenre(genre), [genre])
  const validationSchema = useMemo(() => validationSchemaGenre(), [])

  useBreadcrumbs([{ label: "Generi", href: "/genres/genres" }, { label: "Dettaglio Genere" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{genre?.name}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteGenre.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return updateGenre.mutateAsync(values as Genre).then(() => {
                navigate(`/genres/genres`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <GenreForm />
                </Container>
                <BottomFormFixed url="/genres/genres" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteGenre.isOpen}
        onClose={modalActionsDeleteGenre.close}
        onDelete={() => {
          return deleteGenre.mutateAsync(genre?.id).then(() => {
            navigate(`/genres/genres`)
          })
        }}
        message="Sei sicuro di voler eliminare il genere?"
        title="Elimina Genere"
      />
    </Layout>
  )
}
